<template>
  <div class="text-left">
    <b-modal
      id="Pastespecial"
      button-size="sm"
      size="xl"
      centered
      :title="'Paste Special'"
      v-model="modalShow"
      hide-footer
      no-stacking
      :modal-class="{ 'c-dark-theme': $store.state.darkMode }"
    >
      <b-row class="break-word">
        <b-col cols="12">
          <b-form-group
            label="Paste Item"
            label-for="pasteitem"
            label-cols="12"
          >
            <b-form-textarea
              id="pasteitem"
              v-model="pasteitem"
              placeholder="Paste your data here"
              rows="10"
              class="smalltextarea courier"
            ></b-form-textarea>
          </b-form-group> </b-col
      ></b-row>
      <b-row class="mt-2 text-right">
        <b-col>
          <b-button @click="$bvModal.hide('Pastespecial')" variant="outline-primary" squared size="sm" class="mr-1"
            >Cancel</b-button
          >
          <b-button variant="outline-primary" squared size="sm"
            >Paste It</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Pastespecial",
  data() {
    return {
      busy: false,
      modalShow: false,
      pasteitem: null,
    };
  },
  watch: {
    modalShow: {
      immediate: true,
        async handler(newVal, oldVal) {
        //   await this.load();
        },
    },
  },
};
</script>

<style>
</style>